export enum NlsOrderStatus {
  QuantityPending = 1,
  QuantityFailed,
  QuantityUpdated,
  FinalizePending,
  FinalizeFailed,
  Finalized,
  ShippedPending,
  ShippedFailed,
  Shipped,
}
